<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">
    <div class="d-flex justify-content-between align-items-center m-b-16">
      <mat-card-title class="m-b-0">Lessons Completed</mat-card-title>
      <span class="text-muted f-s-12">{{ periodLabel }}</span>
    </div>
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [plotOptions]="chartOptions.plotOptions"
      [colors]="chartOptions.colors"
      [dataLabels]="chartOptions.dataLabels"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [grid]="chartOptions.grid"
      [tooltip]="chartOptions.tooltip"
    >
    </apx-chart>
  </mat-card-content>
</mat-card>
